<template>
  <div class="main-bas">
    <div class="title-jibne">DCI申诉</div>
    <el-card shadow="never" class="card-aut-cc">
      <div class="navere-tit">
        <span>失败原因：</span> {{ workInfo.errorReasonCn }}
      </div>
      
      <div class="navere-tit">
        <span>作品名称：</span> {{ workInfo.workName }}
      </div>
      <div class="navere-tit">
        <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; DCI：</span>
        {{ workInfo.dciWorkId }}
      </div>
      <div class="navere-tit">
        <span>著作权人：</span> {{ workInfo.authorName }}
      </div>
      <!-- <div class="navere-tit"><span>内容概括：</span></div> -->
    </el-card>

    <el-form
      ref="formName"
      :model="form"
      label-width="199.9988px"
      class="form-aut"
      :rules="rules"
    >
      <el-form-item label="联系人:" prop="contactName">
        <el-input v-model="form.contactName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="contactPhoneNumber">
        <el-input v-model="form.contactPhoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="邮箱:" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="申诉原因:" prop="message">
        <el-input
          v-model="form.message"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmitUpdate">提交</el-button>
        <el-button  @click="onSubmitfanhui">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { feedBackSubmit, workInfo } from "@/api/user.js";

export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      form: {
        // 联系人
        contactName: "",

        // 联系电话
        contactPhoneNumber: "",

        // 业务id DCI返回的id
        dciContentId: "",

        // 邮箱
        email: "",

        // 申诉原因
        message: "",
      },

      rules: {
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactPhoneNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        message: [
          { required: true, message: "请输入申诉原因", trigger: "blur" },
        ],
      },
      workInfo: {},
    };
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    userInfo() {
      return this.$store.state.userInfo.user;
    },
  },
  watch: {},
  async created() {
    if (this.$route.query.dciWorkId) {
      this.active = 1;
      this.dciWorkId = this.$route.query.dciWorkId;

      const res = await workInfo({
        dciWorkId: this.$route.query.dciWorkId,
      });
      console.log("workInfo", res);
      if (res && res.code == 200) {
        this.workInfo = res.data;
      }
    }
  },
  async mounted() {},
  methods: {
    onSubmitUpdate() {
      this.$refs.formName.validate(async (valid) => {
        if (valid) {
          this.form.dciContentId = this.workInfo.dciContentId;
          const res = await feedBackSubmit(this.form);
          console.log(res, "res");
          if (res.code == 200) {
            this.$message.success("申述成功");
            this.$router.push("/DCIRegistration");
          } else {
            this.$message.error("申述失败" + res.msg);
            return false;
          }
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },
    onSubmitfanhui() {
      this.$router.push("/DCIRegistration");
    }
  },
};
</script>
<style lang="scss" scoped>
.main-bas   {
  background-color: #f2f2f2;
  padding: 10px 20px 10px 20px;
}
.title-jibne {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 19.9988px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
  margin-bottom: 10px;
}
.stepscc {
  margin: 30px auto;
  width: 1200px;
}

.unslider {
  margin: 0 auto;
  width: 1200px;
  height: 865.9987px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  > div {
    width: 469.9988px;
    height: 379.9988px;
    border-style: solid;
    border-color: rgba(121, 121, 121, 1);
    border-radius: 10.0012px;
    border-width: 1.0012px;
    text-align: center;
    display: flex;
    &:hover {
      cursor: pointer;
    }
    flex-direction: column;
    justify-content: center;
    > :nth-child(1) {
      font-size: 160.0012px;
    }
    > :nth-child(2) {
      margin: 19.9988px;
      letter-spacing: normal;
      color: #333333;
      line-height: normal;
      font-size: 24px;
      font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
      font-weight: 700;
      font-style: normal;
      white-space: nowrap;
      text-transform: none;
      text-rendering: optimizeLegibility;
      -webkit-font-feature-settings: "kern";
      font-kerning: normal;
    }
  }
}

.form-aut {
  width: 799.9988px;
  margin-top: 49.9987px;
}
.el-select-cc {
  width: 499.9987px;
}
.navere-tit {
  margin-top: 10px;
  > span {
    letter-spacing: normal;
    color: #333333;
    line-height: normal;
    font-size: 16px;
    text-align: left;
    font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
    font-weight: 700;
    font-style: normal;
    white-space: nowrap;
    text-transform: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
  }
  font-size: 14px;
}
.card-aut-cc{
  padding-bottom: 10px;
}
</style>
